import { Injectable } from "@angular/core";

import { Range } from "@codemirror/state";
import { Decoration, EditorView, ViewPlugin, PluginSpec, DecorationSet } from "@codemirror/view";

import { CodeEditorHighlightPlugin, CodeEditorHighlightResolver } from "../models";


@Injectable()
export class CodeEditorHighlightService {

    public getHighlightExtension(pattern: RegExp | string, classes: string): ViewPlugin<CodeEditorHighlightPlugin> {
        if (!pattern || !classes?.length) return null;

        // Function to resolve decoration set given editor view, capturing pattern and CSS classes specified.
        return this.getHighlightPlugin((view: EditorView): DecorationSet => this.highlight(view, pattern, classes));
    }

    public getHighlightPlugin(resolver: CodeEditorHighlightResolver): ViewPlugin<CodeEditorHighlightPlugin> {
        if (!resolver) return null;

        // Extra specifications for the plugin.
        const spec: PluginSpec<CodeEditorHighlightPlugin> = {
            decorations: plugin => plugin.decorations
        };

        // Function to build highlight plugin given the editor view, capturing the resolver.
        return ViewPlugin.define(view => new CodeEditorHighlightPlugin(view, resolver), spec);
    }

    private highlight(view: EditorView, pattern: RegExp | string, classes: string): DecorationSet {
        // Foreach visible range, compute
        const decorations: Range<Decoration>[] = view.visibleRanges.flatMap(range => {
            const regex: RegExp = new RegExp(pattern, "g");

            // Get the matches of the given pattern in the range
            const text: string = view.state.doc.sliceString(range.from, range.to);
            const matches: RegExpMatchArray[] = Array.from(text.matchAll(regex));

            // Create a new decoration mark with the given classes for each one
            return matches.map(match => {
                const start: number = range.from + match.index;
                const end: number = start + match[0].length;

                return Decoration.mark({ class: classes }).range(start, end);
            });
        })

        return Decoration.set(decorations);
    }
}